import React, { useState, useEffect } from 'react';
import { storage } from '../utils/storage';
import { ensureHttps } from '../utils/urlUtils';
import './MatchdaySplash.css';

const MatchdaySplash: React.FC = () => {
  const [showSplash, setShowSplash] = useState(false);
  const [matchdayImage, setMatchdayImage] = useState<string>('');

  useEffect(() => {
    // Pazartesi 00:00 - Salı 06:00 kontrolü
    const now = new Date();
    const dayOfWeek = now.getDay(); // 0 = Pazar, 1 = Pazartesi, 2 = Salı
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const currentTime = hours * 60 + minutes; // Dakika cinsinden

    let shouldShow = false;

    // Pazartesi günü (1) - tüm gün göster
    if (dayOfWeek === 1) {
      shouldShow = true;
    }
    // Salı günü (2) ve saat 06:00'dan önce (06:00 dahil değil)
    else if (dayOfWeek === 2 && currentTime < 6 * 60) {
      shouldShow = true;
    }

    if (!shouldShow) {
      return;
    }

    // Matchday görselini yükle
    const loadMatchdayImage = async () => {
      const settings = await storage.getAdminSettings();
      const image = settings.matchdayImage;
      
      if (!image) {
        return;
      }

      setMatchdayImage(image);
      setShowSplash(true);
    };
    
    loadMatchdayImage();
  }, []);

  const handleClose = () => {
    setShowSplash(false);
  };

  if (!showSplash || !matchdayImage) {
    return null;
  }

  return (
    <div className="matchday-splash-overlay" onClick={handleClose}>
      <div className="matchday-splash-content" onClick={(e) => e.stopPropagation()}>
        <img 
          src={ensureHttps(matchdayImage)} 
          alt="Matchday" 
          className="matchday-splash-image"
        />
        <button className="matchday-splash-close" onClick={handleClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default MatchdaySplash;

